// Matches `border: 1px` on .container in ExternalLink.module.scss.
export const LINK_BORDER_WIDTH = 1
